module.exports = __webpack_public_path__ + "static/media/fly0152.2e022391.webp";